module.exports = __webpack_public_path__ + "img/Arrow_chevron.3936eccb.svg";